export default __webpack_public_path__ + "static/media/HIPAA.b95a0183.png";